import apiClient from './apiClient';

// ============================================================
// Types -- matching backend Go models
// ============================================================

export interface F9421 {
  f9421_01: string;   // 員工代號
  f9421_02: number;   // 項次
  f9421_11: string;   // 薪資代號
  f9421_11a: string;  // 薪資名稱
  f9421_12: number;   // 固定金額
  f9421_13: string;   // 說明
}

export interface F9420 {
  f9420_01: string;        // 員工代號
  f9420_11: number;        // 扣繳所得稅
  f9420_12: number;        // 計薪方式
  f9420_13: string;        // 撥款銀行
  f9420_14: string;        // 撥款帳號
  f9420_15: number;        // 領薪方式
  f9420_16: number;        // 薪資明細筆數
  f9420_17: number;        // 扶養人數
  f9420_18: string | null; // 最後異動日期
  f9420_19: string;        // 異動單號
  f9420_21: number;        // 勞保薪資
  f9420_23: number;        // 健保薪資
  f9420_24: number;        // 健保負擔人數
  f9420_31: number;        // 自願提繳
  f9420_34: number;        // 退休金制度
  f9420_37: number;        // 退休金提繳百分比
  f9420_38: number;        // 退休金月繳工資
  f9420_91: string;        // 建立人員
  f9420_92: string | null; // 建立日期
  f9420_93: string;        // 修改人員
  details: F9421[];        // 薪資明細
}

export interface DetailItem {
  f9421_11: string;   // 薪資代號
  f9421_11a: string;  // 薪資名稱
  f9421_12: number;   // 固定金額
  f9421_13: string;   // 說明
}

export interface CreateRequest {
  f9420_01: string;
  f9420_11: number;
  f9420_12: number;
  f9420_13: string;
  f9420_14: string;
  f9420_15: number;
  f9420_17: number;
  f9420_21: number;
  f9420_23: number;
  f9420_24: number;
  f9420_31: number;
  f9420_34: number;
  f9420_37: number;
  f9420_38: number;
  details: DetailItem[];
}

export interface UpdateRequest {
  f9420_11: number;
  f9420_12: number;
  f9420_13: string;
  f9420_14: string;
  f9420_15: number;
  f9420_17: number;
  f9420_21: number;
  f9420_23: number;
  f9420_24: number;
  f9420_31: number;
  f9420_34: number;
  f9420_37: number;
  f9420_38: number;
  details: DetailItem[];
}

export interface ListResponse {
  data: F9420[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const baseSalaryApi = {
  async list(page = 1, size = 100, keyword?: string): Promise<ListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    const res = await apiClient.get('/api/base-salary', { params });
    return res.data;
  },

  async get(empID: string): Promise<F9420> {
    const res = await apiClient.get(`/api/base-salary/${encodeURIComponent(empID)}`);
    return res.data;
  },

  async create(data: CreateRequest): Promise<F9420> {
    const res = await apiClient.post('/api/base-salary', data);
    return res.data;
  },

  async update(empID: string, data: UpdateRequest): Promise<F9420> {
    const res = await apiClient.put(`/api/base-salary/${encodeURIComponent(empID)}`, data);
    return res.data;
  },

  async delete(empID: string): Promise<void> {
    await apiClient.delete(`/api/base-salary/${encodeURIComponent(empID)}`);
  },
};
